import { styled } from '@mui/material';

export const StyledDonutChartBackground = styled('div')({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	background: '#FFF',
	padding: '6px',
	width: 'fit-content',
	borderRadius: '50%',
});

export const StyledDonutChartWrap = styled('div', {
	shouldForwardProp: (props) => props !== 'size',
})(({ size }: { size: number }) => ({
	position: 'relative',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	width: size,
	height: size,
	borderRadius: '50%',
}));

export const StyledDonutChartBackSvg = styled('svg')({
	transition: 'stroke-dashoffset 0.5s ease',
	transform: 'rotate(-90deg)',
	transformOrigin: '50% 50%',
	position: 'absolute',
	top: 0,
	left: 0,
});

export const StyledDonutChartSegment = styled('circle', {
	shouldForwardProp: (props) => props !== 'offset',
})(({ offset, strokeDasharray }: { offset: number; strokeDasharray: string }) => ({
	strokeLinecap: 'butt',
	strokeDasharray,
	strokeDashoffset: offset,
}));

export const StyledDonutChartTextValue = styled('text')({
	margin: 0,
	fontSize: '12px',
	fontWeight: 400,
	fill: '#FFF',
});

export const StyledDonutChartWithTextWrap = styled('div')({
	display: 'flex',
	gap: '12px',
	justifyContent: 'center',

	'@container (max-width: 300px)': {
		flexDirection: 'column',
		alignItems: 'center',
	},
});

export const StyledDonutChartWithTextList = styled('ul')({
	listStyleType: 'none',
	display: 'flex',
	flexDirection: 'column',
	gap: '4px',
	margin: 0,
	padding: 0,
	alignItems: 'flex-start',

	'@container (max-width: 300px)': {
		alignSelf: 'flex-start',
	},
});

export const StyledDonutChartWithTextListItem = styled('li')({
	display: 'flex',
	justifyContent: 'center',
	gap: '4px',
	fontSize: '14px',
	fontWeight: 400,
	lineHeight: '20px',
	letterSpacing: '0.17px',
});

export const StyledDonutChartWithTextColor = styled('span', {
	shouldForwardProp: (prop) => prop !== 'background',
})(({ background }: { background: string }) => ({
	marginTop: '4px',
	width: '12px',
	minWidth: '12px',
	height: '12px',
	borderRadius: '50%',
	background,
}));
